import { FeatureFlag, UserPermission, UserRole } from '@synergy/models';
import { Navigate } from 'react-router';
import { PoolInstance, isInstance } from '@synergy/config';
import { PropsWithChildren } from 'react';
import { hasFeature, hasPermission, hasRole } from '@synergy/utils';

import { useAppSelector } from '../../../store/use-appstate-selector';

interface AccessControlProps {
    allowedRoles?: UserRole | UserRole[];
    allowedPermissions?: UserPermission | UserPermission[];
    redirect?: boolean;
    allowedFeature?: FeatureFlag;
    allowedInstance?: PoolInstance;
}

export const AccessControl = (props: PropsWithChildren<AccessControlProps>) => {
    const user = useAppSelector(state => state.user);

    if (!user) {
        return null;
    }

    const { allowedRoles, allowedPermissions, allowedFeature, allowedInstance, redirect, children } = props;

    const allowedByRoles = !(allowedRoles && allowedRoles.length > 0) || hasRole(allowedRoles, user);
    const allowedByPermissions =
        !(allowedPermissions && allowedPermissions.length > 0) || hasPermission(allowedPermissions, user);
    const allowedByFeatureFlag = !allowedFeature || hasFeature(allowedFeature);
    const allowedByPoolInstance = !allowedInstance || isInstance(allowedInstance);

    const allowed = allowedByRoles && allowedByPermissions && allowedByFeatureFlag && allowedByPoolInstance;

    if (allowed) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <>{children}</>;
    }

    if (redirect) {
        return <Navigate to="/" />;
    }
    return null;
};
